import { setupFormState } from '@/components/form/tidal-form'
import { SimulationDate, SimulationFormValues } from './typings'
import { getEmptySimulation } from './utils'

const getInitialValues = (): SimulationFormValues => ({
  ...getEmptySimulation(new Date()),
  simulationDate: {
    type: 'fromScratch',
  } as SimulationDate,
})

export const form = setupFormState<SimulationFormValues>({
  id: 'simulationForm',
  initialValues: getInitialValues(),
})
